import React from "react";
import "../../../App.css";
import "../../../css/bootstrap.scss";
import { reduxForm, InjectedFormProps } from "redux-form";
import { connect } from "react-redux";
import { RootState } from "../../store"; // Import the RootState type
import { useSelector } from "react-redux";
import UploadDriverLicense from "./UploadDriverLicense";
import UploadIdentityCard from "./UploadIdentityCard";
import UploadPassport from "./UploadPassport";
import UploadOtherDocument from "./UploadOtherDocument";

interface Props {}
const ManageUploadDocument: React.FC<
  Props & InjectedFormProps<{}, Props, FormData>
> = (props: any) => {
  const selectedDocument = useSelector(
    (state: RootState) => state.auth.selectedDocumentName
  );

  return (
    <>
      {selectedDocument == "Driver License" && <UploadDriverLicense />}
      {selectedDocument == "Identity Card" && <UploadIdentityCard />}
      {selectedDocument == "Passport" && <UploadPassport />}
      {selectedDocument == "Other Identity" && <UploadOtherDocument />}
    </>
  );
};

const form = reduxForm<{}, Props, FormData>({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  form: "wizard",
  enableReinitialize: true,
})(ManageUploadDocument);

export default connect(null)(form);
